module.exports = __webpack_public_path__ + "img/btn-bg-image2.d79e29b2.png";